import { createCanvas } from '@ff-os/shared-react/dom/images/createCanvas';
import { Translate } from '@ff-os/shared-utils/types/Translate';
import { Photo, Pipeline } from 'ff-canvas';
import { addDashedLines } from './addDashedLines';
import { addText } from './addText';
import { scalePlaceholder } from './scalePlaceholder';

export const drawPhotoPlaceholder = (pipeline: Pipeline, t: Translate, photo: Photo) => {

    const bounds = pipeline.boundsOf(photo);

    const { width, height } = scalePlaceholder(pipeline, photo);
    const canvas = createCanvas(width, height);

    const ctx = canvas.getContext('2d')!;
    ctx.fillStyle = 'rgb(246, 246, 246)';

    ctx.fillRect(0, 0, width, height);

    const fontSize = photo.custom.values?.placeholder?.fontSize;

    const scale = width / bounds.width;
    const scaledFontSize = fontSize ? fontSize * scale : 0;

    addDashedLines(ctx, width, height, photo, scale);
    addText(ctx, t, width, height, scaledFontSize, photo.custom.values?.placeholder);

    return canvas as HTMLCanvasElement;
};